import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateDataValue'
})
export class TranslateDataValuePipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  /**
   * 資料物件中的值在語系的切換時，根據指定的欄位名稱取得相對應語系的欄位的值回傳
   * 例如客戶或部門資料會有多個語系的名稱，如果全都串起來顯示可能會太長
   * 所以可以針對選用的語系，呈現該語系的名稱就好
   * 以部門為例，資料物件應該包含 deptNameTw、deptNameCn、deptNameUs
   *
   * @param value 物件儲存的值，預設會用這個顯示 ( 最好是一定要有值，不然如果對應的語系沒有值，就會變成空白了 )
   * @param data 要從哪個物件裡面取語系對應的欄位值
   * @param valueField 要取的欄位名稱 ( 不需要加語系名稱，例如: deptName )
   * @returns 取得相對應語系的欄位的值
   */
  transform(value: string, data: any, valueField: string): string {
    let fieldValue: string = '';
    fieldValue = data[this.transformFieldLang(value, valueField)];
    return fieldValue || value;
  }

    transformFieldLang(value: string, valueField: string): string {
    let fieldLang: string = '';
    const currentLang = this.translateService.currentLang.split('-')[1];
    fieldLang = valueField.concat(currentLang[0].toUpperCase()).concat(currentLang.substring(1).toLowerCase());
    return fieldLang || value;
  }

}
